import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import authApi from "../../api/public";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorageKeys";
import { useDispatch } from "../../redux/hooks";
import { clearAuth } from "../../redux/slices/auth/authSlice";
import { setContact } from "../../redux/slices/contact/contactSlice";
import { setCanRedirect } from "../../redux/slices/redirect/redirectSlice";

import useLocalStorage from "./useLocalStorage";

type LogoutFn = (redirectTo?: string) => Promise<void>;

const useLogout = (): LogoutFn => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [, , deleteInitialPath] = useLocalStorage(
        LOCAL_STORAGE_KEY.INITIAL_PATH,
    );

    return useCallback<LogoutFn>(
        async (redirectTo?: string) => {
            try {
                await authApi.logout();
            } catch (e) {
                console.error(e);
            }

            dispatch(setContact([]));
            dispatch(clearAuth());
            dispatch(setCanRedirect(false));
            history.replace(redirectTo || "/login");
            deleteInitialPath();
        },
        [deleteInitialPath, dispatch, history],
    );
};

export default useLogout;
